import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/sections/Hero';
import { MetaPixel } from '../components/MetaPixel';
// Lazy-load every below-the-fold section so the initial bundle stays tiny.
// Each section is a named export, so we map it to default for lazy.
const Pains = lazy(() => import('../components/sections/Pains').then(m => ({
  default: m.Pains
})));
const SystemIntro = lazy(() => import('../components/sections/SystemIntro').then(m => ({
  default: m.SystemIntro
})));
const Tomos = lazy(() => import('../components/sections/Tomos').then(m => ({
  default: m.Tomos
})));
const Bonuses = lazy(() => import('../components/sections/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('../components/sections/Pricing').then(m => ({
  default: m.Pricing
})));
const MegapackExtra = lazy(() => import('../components/sections/MegapackExtra').then(m => ({
  default: m.MegapackExtra
})));
const Comparison = lazy(() => import('../components/sections/Comparison').then(m => ({
  default: m.Comparison
})));
const TestimonialsFull = lazy(() => import('../components/sections/TestimonialsFull').then(m => ({
  default: m.TestimonialsFull
})));
const Guarantee = lazy(() => import('../components/sections/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('../components/sections/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('../components/sections/Footer').then(m => ({
  default: m.Footer
})));
// FloatingElements is non-critical UI (purchase popups); defer it too.
const FloatingElements = lazy(() => import('../components/FloatingElements').then(m => ({
  default: m.FloatingElements
})));
// Lightweight fallback that reserves vertical space without blocking paint.
const SectionFallback = () => <div className="min-h-[40vh]" aria-hidden data-id="element-316" />;
export const Landing = () => {
  return <div className="min-h-screen bg-gray-50 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-317">
      <MetaPixel data-id="element-318" />
      <Hero data-id="element-319" />
      <Suspense fallback={<SectionFallback data-id="element-321" />} data-id="element-320">
        <Pains data-id="element-322" />
        <SystemIntro data-id="element-323" />
        <Tomos data-id="element-324" />
        <Bonuses data-id="element-325" />
        <Pricing data-id="element-326" />
        <MegapackExtra data-id="element-327" />
        <Comparison data-id="element-328" />
        <TestimonialsFull data-id="element-329" />
        <Guarantee data-id="element-330" />
        <FAQ data-id="element-331" />
        <Footer data-id="element-332" />
        <FloatingElements data-id="element-333" />
      </Suspense>
    </div>;
};